import * as React from 'react';
import { SearchbarBuilder, SearchbarProps } from '@components/form/searchbar';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { Dispatch } from 'redux';
import {
  SearchArtists,
  SearchArtistsReset,
} from '@webapp/store/artist/action-creators';
import SimpleArtist from '@common/types/artist/simple-artist';
import { SEARCH_ARTISTS } from '@webapp/store/artist/actions';
import Avatar from '@components/basics/avatar';

export interface ArtistsSearchCtrlProps extends SearchbarProps<SimpleArtist> {
  id?: string;
  isLoading: boolean;
  currentValues?: SimpleArtist[];
  filterRepeated?: boolean;
  search: (value: string) => SearchArtists;
  resetSearch: () => SearchArtistsReset;
}

const mapStateToProps = (state: AppState) => ({
  results: state.artist.search,
  isLoading: !!state.ui.loading[SEARCH_ARTISTS],
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  search: (value: string) => dispatch(new SearchArtists(value)),
  resetSearch: () => dispatch(new SearchArtistsReset()),
});

const Searchbar = SearchbarBuilder<SimpleArtist>();

export const ArtistsSearchCtrl: React.FC<ArtistsSearchCtrlProps> = ({
  filterRepeated = true,
  ...props
}) => {
  const filterResult = (result: SimpleArtist) => {
    if (!result.isActive) {
      return false;
    }
    if (!props.currentValues) {
      return true;
    }

    return filterRepeated
      ? !props.currentValues.find(
          (a) =>
            a.id === result.id ||
            a.name.toLowerCase().trim() === result.name.toLowerCase().trim()
        )
      : true;
  };

  return (
    <Searchbar
      {...props}
      valueMapper={(value) => value.name}
      keyMapper={(value) => value.id}
      filterList={filterResult}
      customBorderRadius={props.customBorderRadius}
      decorationMapper={(value) =>
        value.avatar ? <Avatar src={value.avatar} /> : <Avatar />
      }
      wrapperClassName={'searchbar-wrapper'}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ArtistsSearchCtrl);
